<style>

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
  color: white;
}

.center{
  text-align: center;
}

.center2{
  margin-top: 30px;
  text-align: center;
  color: white;
}

.icon-check{
  font-size: 60px;
  color: green;
}

.icon-clear{
  font-size: 40px;
  color: red;
}
.does-not-match{
  font-size: 25px;
  color: white;
}

.clear-code-margin{
  margin-top: 10px;
}
</style>

<div class="bg">
  <div class="title-signup">Verify your email</div>
  <div class="margin"><TextMessageCode bind:verifyCode="{emailCode}" on:check="{check}" on:clear="{ () => {valid = -1} }"></TextMessageCode></div>
  <div class="margin small">Check your email for a six digit code.  If you don't see anything, make sure to check your spam box.</div>
  
  {#if valid == -1 || valid == 0}
  <div class="margin center" on:click="{sendCodeAgain}"><i class="icon-refresh"></i> Send code again</div>
  {/if}
  
  <div class="center2">
    {#if valid == 1}
      <div>
        <i class="icon-check"></i>
      </div>
      <div>
        Verified!
      </div>
    {:else if valid == 0}
      <i class="icon-clear"></i>
      <div class="does-not-match">Sorry, that does not match</div>
      <div class="clear-code-margin"><button on:click="{clearCode}">Try Again</button></div>
    {/if}
  </div>
  
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import TextMessageCode from "../../../../components/TextMessageCode.svelte";
import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Normalize from "../../../../helpers/Normalize.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  // 420024
  
  allowSignup = true;
  Signup.saveToPersonalObject("emailCode", "");
  Signup.saveToPersonalObject("emailCodeSaved", false);
  emailCodeSaved = Signup.getPersonalObject("emailCodeSaved");
  emailCode = Signup.getPersonalObject("emailCode");

  if (emailCodeSaved == true) {
    valid = 1;
    nextDisabled = false;
  } else {
    check();
  }
  
});


let allowSignup = false;
let emailCode = "";
let emailCodeSaved = false;
let valid = -1;
let nextDisabled = true;


async function check() {
  if (emailCode == "") return;
  
  if (emailCodeSaved == true) {
    valid = 1;
    nextDisabled = false;
  } else {
    try {
      Validate.allowSignup(allowSignup);
      Validate.textCode(emailCode);
      await Signup.verifyEmail(emailCode);
      Signup.saveToPersonalObject("emailCode", emailCode);
      Signup.saveToPersonalObject("emailCodeSaved", true);
      valid = 1;
      nextDisabled = false;
    } catch (e) {
      nextDisabled = true;
      valid = 0;
      console.log("error:", e);
    }
  }
}


function clearCode() {
  emailCode = "";
  valid = -1;
}


function sendCodeAgain() {
  // resend the validation code
  // set up a timeout so they can't send a new code a bunch of times
}


function next() {
  push("/signup/profile/personal/generate-keys");
}


</script>